/**
 * A value held outside React state, read with `useSyncExternalStore` by the
 * one component that shows it. The review grid's overlays (a header note, the
 * editor's note, a cell's comments) live in these: setting state in the grid
 * would re-render it, and only the overlay needs to.
 */
export interface ValueStore<Value> {
  get: () => Value;
  set: (next: Value) => void;
  subscribe: (listener: () => void) => () => void;
}

export function createValueStore<Value>(initial: Value): ValueStore<Value> {
  let value = initial;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set(next) {
      value = next;
      for (const listener of listeners) listener();
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
